export class ListZeroEtlPoliciesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListZeroEtlPoliciesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortZeroEtlPolicyBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlPoliciesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
